var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutIconThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 416,
    viewBox: "0 0 240 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.656,
    y: 261.008,
    width: 211.457,
    height: 211.457,
    rx: 40,
    transform: "rotate(147.703 436.656 261.008)",
    fill: "#025DE8",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.016,
    y: 245.203,
    width: 211.457,
    height: 211.457,
    rx: 40,
    transform: "rotate(147.703 400.016 245.203)",
    fill: "#025DE8",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.377,
    y: 229.4,
    width: 211.457,
    height: 211.457,
    rx: 40,
    transform: "rotate(147.703 363.377 229.4)",
    fill: "#025DE8",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.73,
    y: 223.494,
    width: 211.457,
    height: 211.457,
    rx: 40,
    transform: "rotate(147.703 334.73 223.494)",
    fill: "#025DE8",
    fillOpacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIconThree);
export default __webpack_public_path__ + "static/media/about_icon_three.dc1137905a25b3e83efca9789a7755e2.svg";
export { ForwardRef as ReactComponent };